import React from 'react';
import classes from './Logo.css'
const logo = (props) => {
const classNames = [classes.appLogo];
if(props.isFixedSize) {
    classNames.push(classes.appLogoFixedSize);
}

if(props.isTop30Margin) {
    classNames.push('appMTop30');
}

if(props.isBottom30Margin) {
    classNames.push('appMBottom30')
}
return (
<div className={classNames.join(' ')}>
M
</div>);
}; 


export default logo;


// WEBPACK FOOTER //
// ./src/components/UI/Logo/Logo.js